import { useMemo } from "react"

import { Project } from "shared/types/Project"

import {
  useProjectByShareLinkQuery,
  useProjectChildrenByShareLinkQuery
} from "features/project-sharing/graphql/queries.generated"

export function useSharedProjectData(shareID: string | undefined) {
  const {
    data,
    loading: isLoading,
    error
  } = useProjectByShareLinkQuery({
    variables: { id: shareID || "" },
    skip: !shareID
  })
  const { data: projectChildrenData, loading: isLoadingChildren } =
    useProjectChildrenByShareLinkQuery({
      variables: { id: shareID || "" },
      skip: !shareID
    })

  const project: Project | null | undefined = useMemo(() => {
    if (projectChildrenData?.projectByShareLink) {
      return {
        ...projectChildrenData.projectByShareLink,
        children: projectChildrenData.projectByShareLink.children
      }
    }
    return data?.projectByShareLink
  }, [data, projectChildrenData])

  return {
    project,
    isLoading,
    isLoadingChildren,
    error
  }
}
